export const liveRadioConstant = {
    recentlyPlayedTracksPollInterval: 10000,
    coverSize: 480
};
